import { Container } from '@hover/blueprint';
import React, { useState } from 'react';
import Desktop from './Desktop';
import MobileAndTablet from './MobileAndTablet';
import { HeaderDescription } from '../../common';

const HowHoverWorks: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<number>(0);

  const setTab = (tabId: number) => {
    setCurrentTab(tabId);
    const elm = document.getElementById(`how-does-it-works-sign`);
    if (elm) {
      window.scrollTo({
        top: elm.getBoundingClientRect().top + window.scrollY + tabId * 81 - 70,
      });
    }
  };

  return (
    <Container
      maxW="1248px"
      centerContent
      mb={1000}
      px={{ base: 0, desktop: 500 }}
    >
      <HeaderDescription
        mb="80px"
        px={{ base: 500, tablet: 300 }}
        maxWidth="750px"
        heading="How does HOVER work?"
        body="HOVER generates the most accurate measurements (and a whole lot more) from a few photos of your home."
      />
      <Desktop currentTab={currentTab} setCurrentTab={setCurrentTab} />
      <MobileAndTablet currentTab={currentTab} setCurrentTab={setTab} />
    </Container>
  );
};

export default HowHoverWorks;
